// 店铺保证金 / 首笔推广金 缴纳相关接口

// 获取当前选中店铺的保证金/推广金状态（轻量）
export const getDepositPromoStatus = $axios =>
  $axios({
    url: '/deposit-promo/status',
    method: 'get'
  }).then(res => res.data)

// 获取当前选中店铺的保证金/推广金详情（含收款信息、支付宝二维码等）
export const getDepositPromoDetail = $axios =>
  $axios({
    url: '/deposit-promo/detail',
    method: 'get'
  }).then(res => res.data)

// 提交付款凭证，可一次提交保证金、推广金，或两者一起提交
// data: { fundTypes: number[], paymentMethod: number, voucherFiles: string[] }
export const submitDepositPromo = ($axios, data) =>
  $axios({
    url: '/deposit-promo/submit',
    method: 'post',
    data
  }).then(res => res.data)
